/**
 *  @class
 *  @function ContentGrid
 */
if (!customElements.get('content-grid')) {
    class ContentGrid extends HTMLElement {
        static get observedAttributes() {
            return ['selected-index'];
        }
        constructor() {
            super();
        }

        connectedCallback() {
            const cg = this;
            this.selectedIndex = this.selectedIndex;
            this.buttons = Array.from(this.querySelectorAll('.content-grid__tabs a'));
            this.panels = Array.from(this.querySelectorAll('.content-grid__inner_tab'));
            this.collapsibleVideos = Array.from(this.querySelectorAll('.content-grid__column_collapsible_text video'))
            this.collapsibleTextToggles = Array.from(this.querySelectorAll('.content-grid__collapsible_text_toggle'))
            this.buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    this.selectedIndex = index;
                });
            });
            this.collapsibleVideos.forEach((video, index) => {
                const background = video.closest(".content-grid__column_bg");
                // Autoplay
                if (window.innerWidth < 768) {
                    if (!background.dataset.autoplayMobile) {
                        video.pause();
                    }
                } else {
                    if (!background.dataset.autoplayDesktop) {
                        video.pause();
                    }
                }
                // Touch to play/pause for mobile
                let isTouch = false
                background.addEventListener('touchstart', () => {
                    isTouch = true;
                });
                background.addEventListener('click', () => {
                    if (isTouch) {
                        if (video.paused) {
                            video.play();
                        } else {
                            video.pause();
                        }
                    }
                });
                // Play on hover for desktop
                background.addEventListener('mouseover', () => {
                    if (video.paused) {
                        video.play();
                    }
                });
                background.addEventListener('mouseout', () => {
                    if (!video.paused) {
                        video.pause();
                    }
                });
            });
            this.collapsibleTextToggles.forEach((button, index) => {
                cg.collapsibleUpdateState(button.closest('.content-grid__collapsible_text_overlay'));
                button.addEventListener('click', (e) => {
                    e.stopPropagation();
                    cg.collapsibleUpdateState(button.closest('.content-grid__collapsible_text_overlay'), true);
                });
            });
            if (Shopify.designMode) {
                this.addEventListener('shopify:block:select', (event) => {
                    this.selectedIndex = this.buttons.indexOf(event.target);
                });
            }
        }
        collapsibleUpdateState(text_overlay, doToggle) {
            const text_content = text_overlay.querySelector('.content-grid__collapsible_text');
            const text_preview = text_content.querySelector('.content-grid__collapsible_text_preview');
            const text_details = text_content.querySelector('.content-grid__collapsible_text_details');
            if (doToggle) {
                text_overlay.classList.toggle('open');
            }
            if (text_overlay.classList.contains('open')) {
                const details_margin = parseInt(window.getComputedStyle(text_details)['marginTop']);
                text_content.style.height = (text_preview.offsetHeight + details_margin + text_details.offsetHeight)+"px";
            } else {
                text_content.style.height = text_preview.offsetHeight+"px";
            }
        }
        get selectedIndex() {
            return parseInt(this.getAttribute('selected-index')) || 0;
        }
        set selectedIndex(index) {
            this.setAttribute('selected-index', index);
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
                this.buttons[oldValue].classList.remove('active');
                this.buttons[newValue].classList.add('active');
                this.panels[parseInt(oldValue)].classList.remove('active');
                this.panels[parseInt(newValue)].classList.add('active');
                if (typeof Flickity == "function") {
                    // Resize sliders within the tabs content
                    this.panels[parseInt(newValue)].querySelectorAll("slide-show.flickity-enabled").forEach((flickityElement) => {
                        Flickity(flickityElement).resize();
                    });
                }
            }
        }
    }
    customElements.define('content-grid', ContentGrid);
}
